import { Box, BoxProps } from '@material-ui/core'
import styled from 'styled-components'

interface IFormStackProps extends BoxProps {
  spacing?: number
}

export const FormStack = styled(Box)<IFormStackProps>`
  & > * + * {
    margin-top: ${({ theme, spacing = 2 }) =>
      theme.spacing ? theme.spacing * spacing : 8 * spacing}px;
  }
`
